module.exports = __webpack_public_path__ + "img/status-cancel.6ca0bb59.svg";